module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/logo-mygames.b24fe740.svg";